import httpClient from "@/utils/httpClient";
import type { ApiPayload } from "@/types/api";

const custAccountOperationServices = {
  getCustAccountList: async <Response = unknown>() =>
    httpClient.get<Response>("/custAccountOperations/getCustAccountList"),
  getCustAccountDetail: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/custAccountOperations/getCustAccountDetail", data),
  getTransactionList: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/custAccountOperations/getTransactionList", data),
  getTransactionDetail: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/custAccountOperations/getTransactionDetail", data),
  getCorporatedCustAccountReceipt: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/report/getCorporatedCustAccountReceipt", data),
  getCorporatedCustAccountStatementList: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/report/getCorporatedCustAccountStatementList", data),
  getTransferReceipt: async <Response = unknown>(data: ApiPayload) =>
    httpClient.post<Response>("/report/getTransferReceipt", data),
};

export default custAccountOperationServices;
